import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Button } from '../../../../components/Buttons';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import { Modal, ModalControls } from '../../../../components/Modal';
import { VehicleAvatar } from '../../../../components/VehicleAvatar';
import { selectWorks } from '../../../Api/selectors';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import { performAction } from '../../actions';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { Cell } from '../Cell';
import { PerformActionButton } from '../PerformActionButton';
import { BaseCellComp } from '../BaseCellComp';
import { CellButton, CellButtons } from '../CellButton';
import { Well } from '../../../../components/Well';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { VBox } from '../../../../components/Box';
import { VehiclePropertyEditableInput } from '../../../Vehicles/components/VehiclePropertyEditableInput';
import { setVehicleProperty } from '../../../Vehicles/actions';
import { VehiclePropertyLoadable } from '../../../Vehicles/components/VehiclePropertyLoadable';

const Container = styled.div`
  .formField {
    width: 100%;
    .form-control {
      > div {
        width: 100%;
      }
    }
  }
`;

const STATE = {
  approve: false,
  regplate_code: '',
};

/* eslint-disable react/prefer-stateless-function */
class WIENTJES_labelsComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  get vehicle() {
    return this.props.cell.vehicle;
  }

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <Modal onClose={this.reset.bind(this)} title={this.props.action.label}>
        <WithVehicle vehicle_id={this.vehicle.id}>
          <VehicleHeader vehicle={this.vehicle} />
          
          <h3 style={{color: 'red'}}>{this.vehicle.task_AVN ? "AVN voertuig" : "" }</h3>

          <VBox gap="24px" padding="24px 0">
            <VehiclePropertyEditableInput propertyName="mileage" vehicle_id={this.vehicle.id} />
            <VehiclePropertyEditableInput propertyName="vin" vehicle_id={this.vehicle.id} />
            <VehiclePropertyEditableInput propertyName="num_keys" vehicle_id={this.vehicle.id} />
          </VBox>

          <ModalControls>
            <VehiclePropertyLoadable name="label_printer_queue">
              <Button primary onClick={this.props.print}>
                print
              </Button>
            </VehiclePropertyLoadable>
          </ModalControls>
          <ModalControls>
            <PerformActionButton action={this.props.action} target={this.vehicle} onChange={this.reset.bind(this)} />
            <Button onClick={this.reset.bind(this)}>{this.lbl('cancel')}</Button>
          </ModalControls>
        </WithVehicle>
      </Modal>
    );
  }

  render() {
    const vehicle = this.vehicle;
    return (
      <Cell>
        <Container>
          <VehicleHeader vehicle={vehicle} />

          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                <CellButton
                  onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle.regplate_code || '' })}
                >
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
        </Container>
        {this.renderApprove()}
      </Cell>
    );
  }
}

WIENTJES_labelsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle.id}`]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    confirm(vehicle_id, regplate_code) {
      dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    },
    print() {
      dispatch(setVehicleProperty(ownProps.cell.vehicle.id, 'label_printer_queue', '1'));
    },
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const WIENTJES_labels = compose(
  withConnect,
  withRouter,
)(WIENTJES_labelsComp);
